/*
 * Search placeholder that types real queries — "худі|", "бомбер|" — so an
 * empty field shows what it can find instead of a bare "Search".
 *
 * It only runs while the input is on screen and empty (the search modal is a
 * dialog that is closed most of the time), stops for good once the customer
 * types, and never runs with prefers-reduced-motion: there the placeholder is
 * a plain hint with the first query.
 *
 * Queries come from data-cp-typing on the input, comma-separated, so the
 * list is edited in Liquid next to the markup, not in this file.
 */
(function () {
  document.querySelectorAll('[data-cp-typing]').forEach(run);

  function run(input) {
    var words = input.dataset.cpTyping.split(',').map(function (w) { return w.trim(); }).filter(Boolean);
    var base = input.dataset.cpTypingBase || 'Пошук';
    if (!words.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      input.placeholder = base + ': ' + words[0];
      return;
    }

    var word = 0;
    var chars = 0;
    var deleting = false;
    var timer = null;
    var visible = false;

    function tick() {
      timer = null;
      if (!visible || input.value) return;

      var target = words[word];
      chars += deleting ? -1 : 1;
      input.placeholder = target.slice(0, chars) + '|';

      var delay = deleting ? 45 : 90;
      if (!deleting && chars >= target.length) {
        deleting = true;
        delay = 1400;
      } else if (deleting && chars <= 0) {
        deleting = false;
        word = (word + 1) % words.length;
        delay = 300;
      }
      timer = setTimeout(tick, delay);
    }

    function start() {
      if (!timer && visible && !input.value) timer = setTimeout(tick, 400);
    }

    function stop() {
      clearTimeout(timer);
      timer = null;
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) start(); else stop();
      }).observe(input);
    }

    input.addEventListener('input', function () {
      if (input.value) {
        stop();
      } else {
        start();
      }
    });
  }
})();

/*
 * Recent searches. The last three queries a customer submitted, kept in
 * localStorage and shown as chips above the category chips while the field
 * is empty. Saved on form submit only — a predictive keystroke is not a
 * search the customer would want to see again.
 */
(function () {
  var KEY = 'cp:recent-searches';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }

  function save(q) {
    q = (q || '').trim().slice(0, 40);
    if (q.length < 2) return;
    var list = read().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    list.unshift(q);
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 3))); } catch (e) {}
  }

  function paint() {
    var list = read();
    document.querySelectorAll('[data-cp-recent]').forEach(function (box) {
      box.querySelectorAll('a').forEach(function (a) { a.remove(); });
      if (!list.length) { box.hidden = true; return; }
      list.forEach(function (q) {
        var a = document.createElement('a');
        a.className = 'cp-search-chip';
        a.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'search?q=' + encodeURIComponent(q);
        a.textContent = q;
        box.appendChild(a);
      });
      box.hidden = false;
    });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('form[action*="/search"]')) return;
    var input = form.querySelector('[name="q"]');
    if (input) save(input.value);
  }, true);

  var q = new URLSearchParams(location.search).get('q');
  if (q && /\/search/.test(location.pathname)) save(q);

  paint();
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      for (var j = 0; j < muts[i].addedNodes.length; j++) {
        var n = muts[i].addedNodes[j];
        if (n.nodeType === 1 && (n.matches('[data-cp-recent]') || n.querySelector('[data-cp-recent]'))) { paint(); return; }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
